import { Dropdown, Image } from 'react-bootstrap';
import defaultProfileImage from '../../assets/img/ic-img.svg';
import { getMessageSenderName, formatMessageTime } from '../../utils/conversations';

// Custom toggle with no default caret/button chrome — a plain "⋮" affordance,
// matching the project's existing convention of small unicode glyph controls
// (e.g. the "×" remove buttons on Support's attachment previews) over adding
// another icon asset for a one-off menu trigger.
const KebabToggle = ({ onClick }) => (
    <button
        type="button"
        className="message-bubble__menu-toggle"
        aria-label="Message options"
        onClick={(e) => { e.preventDefault(); onClick(e); }}
    >
        &#8942;
    </button>
);

const MessageBubble = ({ message, isOwn, onReportMessage, onReportStudent, onBlockStudent }) => {
    const senderName = getMessageSenderName(message.sender);
    const canModerate = !isOwn && message.sender?._id;

    return (
        <div className={`message-bubble${isOwn ? ' message-bubble--own' : ''}${message.isDeleted ? ' message-bubble--deleted' : ''}`}>
            {!isOwn && (
                <Image
                    src={message.sender?.profileImage || defaultProfileImage}
                    alt=""
                    className="message-bubble__avatar"
                />
            )}

            <div className="message-bubble__content">
                {!isOwn && <div className="message-bubble__sender">{senderName}</div>}

                <div className="message-bubble__row">
                    <div className="message-bubble__balloon">
                        {message.isDeleted ? (
                            <span className="message-bubble__removed">Message removed</span>
                        ) : (
                            <span className="message-bubble__text">{message.text}</span>
                        )}
                    </div>

                    {canModerate && (
                        <Dropdown align="end" className="message-bubble__menu">
                            <Dropdown.Toggle as={KebabToggle} />
                            <Dropdown.Menu>
                                {!message.isDeleted && (
                                    <Dropdown.Item onClick={() => onReportMessage(message)}>Report message</Dropdown.Item>
                                )}
                                <Dropdown.Item onClick={() => onReportStudent(message.sender)}>Report student</Dropdown.Item>
                                <Dropdown.Item onClick={() => onBlockStudent(message.sender)}>Block student</Dropdown.Item>
                            </Dropdown.Menu>
                        </Dropdown>
                    )}
                </div>

                <div className="message-bubble__time">
                    {formatMessageTime(message.createdAt)}
                    {message.pending && <span className="message-bubble__pending"> · Sending…</span>}
                </div>
            </div>
        </div>
    );
};

export default MessageBubble;
